export interface RechargeBonusLevelValue {
    threshold?: number | string | null
    bonus_amount?: number | string | null
}

export const validateRechargeBonusLevels = (levels: RechargeBonusLevelValue[] = []) => {
    for (let index = 1; index < levels.length; index++) {
        const previousBonusAmount = Number(levels[index - 1].bonus_amount || 0)
        const currentBonusAmount = Number(levels[index].bonus_amount || 0)
        if (currentBonusAmount < previousBonusAmount) return '赠送余额需要随充值档位递增或持平'
    }

    return ''
}
